export const filterContext = {
  itemById: '/filter-service/api/external/items/{id}',
  sku: '/filter-service/api/external/sku',
};
